export const infoConfig = {
	name: "House Ana",
	guests: 2,
	extraGuests: 2,
	coords: [45.1785391, 14.1235475],
	googleMapsLink: 'https://maps.app.goo.gl/jyoeajuTQmbDidjr6',
	address: 'Veljaki 42A, 52223 Kršan, Croatia',
	wappLink: 'https://wa.me/385914863186',
	phone: '+385 91 4863 186', // when changing phone, remember to change wapp link
	email: 'irenabasic76@gmail.com',
};

export const discoverLinks = [
	{
		name: 'discover.krsan',
		link: 'https://www.istria-krsan.com/en/hr',
	},
	{
		name: 'discover.labin',
		link: 'https://rabac-labin.com/en/',
	},
	{
		name: 'discover.istria',
		link: 'https://www.istra.hr/en',
	},
];

import { markRaw } from "vue";
import ACIcon from "@/components/icons/ACIcon.vue";
import WifiIcon from "@/components/icons/WifiIcon.vue";
import TvIcon from "@/components/icons/TvIcon.vue";
import WasherIcon from "@/components/icons/WasherIcon.vue";
import GrillIcon from "@/components/icons/GrillIcon.vue";
import BalconyIcon from "@/components/icons/BalconyIcon.vue";
import ShowerIcon from "@/components/icons/ShowerIcon.vue";
import GardenIcon from "@/components/icons/GardenIcon.vue";
import PawIcon from "@/components/icons/PawIcon.vue";

export const services = [
	{
		name: 'services.garden',
		icon: markRaw(GardenIcon),
	},
	{
		name: 'services.petFriendly',
		icon: markRaw(PawIcon),
	},
	{
		name: 'services.outdoorKitchen',
		icon: markRaw(GrillIcon),
	},
	{
		name: 'services.porch',
		icon: markRaw(BalconyIcon),
	},
	{
		name: 'services.ac',
		icon: markRaw(ACIcon),
	},
	{
		name: 'services.freeWifi',
		icon: markRaw(WifiIcon),
	},
	{
		name: 'services.tv',
		icon: markRaw(TvIcon),
	},
	{
		name: 'services.washer',
		icon: markRaw(WasherIcon),
	},
	{
		name: 'services.bathroom',
		icon: markRaw(ShowerIcon),
	},
];
